// removed by extract-text-webpack-plugin
module.exports = {"received":"qempo_PaymentBox_received-2mO8Sfu","canceled":"qempo_PaymentBox_canceled-1RMsV3z"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/payments/components/PaymentsReceived/PaymentBox/PaymentBox.scss
// module id = 1765
// module chunks = 0